<template>
<div>
    <div class="pop_open ms-2" @click="showModal">
        <div class="info_icon">
            <SvgHeaderSvg :type="'info'" />
            </div>
    </div>
    <div v-if="flagShowModal">
        <Teleport  to="#teleports">
            <div class="modal fade" data-bs-backdrop="true"  id="diamondquality" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="diamondquality">
                <div class="modal-dialog">
                    <div class="modal-body modal-content">                     
                        
                        <div class="title_block mb-2">
                            <h3 class="mb-0 font-active">Diamond Quality</h3>
                            <span @click="hideModal"><SvgHeaderSvg type="close" class="largesvg"/></span>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-12">
                                <div class="m-info">
                                    <p>
                                        Diamond quality encompasses both color and clarity of your diamond. We classify it into two categories:<br><br>

                                        <strong>FG-VS:</strong> FG-VS diamonds showcase high-quality clarity with only minor inclusions that may not be visible without a microscope. They are near-colorless, making them a perfect balance of luxury and value.<br>

                                        <strong>DE-VVS:</strong> These diamonds are exceptional in quality. Diamonds graded DE-VVS offer near-flawless clarity and are colorless. These diamonds radiate brilliance.<br><br>
                                        <strong>*Applies exclusively to the center stone</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</div>
</template>

<script setup>
const flagShowModal = ref(false)
const diamondquality = ref(null)

const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = diamondquality.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };

    const hideModal = () => {
        const modalElement = diamondquality.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };
</script>

<style scoped>
.largesvg {
    transform: scale(1.3);
    }
.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
p {
    font-size: 16px;
    color: #6a6161;
    font-weight: normal;
    text-transform: none;
}
.title_block span {
    cursor: pointer;
}
h3{
    font-size: 22px;
}

@media(max-width: 767px){
    h3{
        font-size: 20px;
    }
    p{
        font-size: 14px;
    }
}

</style>